import links from 'common/helpers/links'

import messages from '../messages'


const getSkincareCollections = ({ gender, collections }) => {
  const collectionsItem = ({
    title: messages.collections,
    to: gender === 'male' ? links.skincareCollectionMenNew : links.skincareCollectionWomenNew,
    dataTestId: gender === 'male' ? 'skincareCollectionsMen' : 'skincareCollectionsWomen',
  })

  if (collections) {
    collectionsItem.subNav = gender === 'male' ? collections.collectionsMen : collections.collectionsWomen
  }

  return collectionsItem
}


export default getSkincareCollections
